import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function EmployeeContractIcon({ className }: IconProps) {
  return (
    <svg
      width="78"
      height="79"
      viewBox="0 0 78 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_599)">
        <path
          d="M69.0655 78.1418V3.54545C69.0655 1.58364 67.4818 0 65.52 0H3.54545C1.58364 0 0 1.58364 0 3.54545V68.64C0 73.8873 4.25455 78.1418 9.50182 78.1418H69.0655Z"
          fill="#EAEDF8"
        />
        <path
          d="M9.62012 78.1418C14.2056 78.1418 18.011 74.7382 18.6019 70.3182C18.6965 69.6091 19.2874 69.0654 19.9965 69.0654H76.5583C77.4565 69.0654 78.1183 69.8691 77.9529 70.7436C77.1729 74.9509 73.4619 78.1418 69.0183 78.1418H9.62012Z"
          fill="#00C4B3"
        />
        <path
          d="M54.6706 35.6199C54.6234 30.0417 52.4252 24.7945 48.4543 20.8235C44.4361 16.8054 39.1179 14.6072 33.4452 14.6072C27.7725 14.6072 22.4306 16.8054 18.4361 20.8235C14.4179 24.8417 12.2197 30.1599 12.2197 35.8326C12.2197 41.5054 14.4179 46.8235 18.4361 50.8417C22.3361 54.7417 27.5125 56.9399 33.0434 57.0344H33.4452C39.1179 57.0344 44.4597 54.8363 48.4543 50.8181L49.187 50.0854L45.9252 46.8235L45.1925 47.5563C42.0488 50.6999 37.8888 52.4254 33.4452 52.4254C29.0015 52.4254 24.8179 50.6999 21.6979 47.5563C18.5543 44.4126 16.8288 40.2526 16.8288 35.809C16.8288 31.3654 18.5543 27.2054 21.6979 24.0617C24.8415 20.9181 29.0015 19.1926 33.4452 19.1926C37.8888 19.1926 42.0488 20.9181 45.1925 24.0617C47.7925 26.6381 49.4234 29.9472 49.8961 33.4926H46.4215C45.9488 30.8454 44.6961 28.4108 42.7579 26.4726C40.2761 23.9908 36.9434 22.6199 33.4215 22.6199C29.8997 22.6199 26.5906 23.9908 24.0852 26.4726C21.5797 28.9544 20.2325 32.2635 20.2325 35.7854C20.2325 39.3072 21.6034 42.6163 24.0852 45.0981C26.5197 47.5326 29.7579 48.9035 33.1852 48.9508H33.4215C36.9434 48.9508 40.2525 47.5799 42.7579 45.0981L43.467 44.3654L40.2052 41.1035L39.4725 41.8363C37.8652 43.4435 35.6906 44.3417 33.4215 44.3417C31.1525 44.3417 28.9779 43.4435 27.3706 41.8363C26.307 40.7726 25.5743 39.4963 25.1725 38.0781H54.647V35.5726M33.4215 33.4926H25.1725C25.5743 32.0981 26.307 30.7981 27.3706 29.7345C28.9779 28.1272 31.1525 27.229 33.4215 27.229C35.6906 27.229 37.8652 28.1272 39.4725 29.7345C40.5361 30.7981 41.2688 32.0744 41.6706 33.4926H33.4215Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_599">
          <rect width="78" height="78.1418" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
